import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';
import { Booth, BoothFetchingState, BoothFetchedLevel } from './types';
import { selectAllBoothTiers } from '../boothTiers';

export const boothsAdapter = createEntityAdapter<Booth>();

const constanceEmptyObject = {};
export const selectBoothsState = (state: any) => state.cms?.booths || constanceEmptyObject;

export const {
  selectIds: selectBoothIds,
  selectEntities: selectBoothEntities,
  selectAll: selectAllBooths,
  selectById: selectBoothById,
  selectTotal: selectTotalBooths,
} = boothsAdapter.getSelectors(selectBoothsState);

export const selectBoothPageInfo = createSelector(
  (state: any) => state.cms.booths,
  (booths) => booths.pageInfo,
);

export const selectAllValidBooths = createSelector(
  selectAllBooths,
  (booths) => booths.filter((it) => it.name && Object.values(it.name).some((name) => name)),
);

export const selectAllValidBoothIds = createSelector(
  selectAllValidBooths,
  (booths) => booths.map((booth) => booth.id),
);

export const selectBoothIdIndex = (boothId: string | number) => createSelector(
  selectAllValidBoothIds,
  (boothIds) => boothIds.findIndex((id) => `${id}` === `${boothId}`),
);

export const selectBoothNotFoundById = createSelector(
  selectBoothById,
  (booth) => booth?.$fetchingState === BoothFetchingState.Rejected
    && !booth?.$fetchedLevel?.find((it) => it.level === BoothFetchedLevel.Meta),
);

export const selectBoothRootContentElementById = createSelector(
  selectBoothById,
  (booth) => booth?.rootContentElement || { tabs: [] },
);

export const selectFetchingStateByBoothId = createSelector(
  selectBoothById,
  (booth) => booth?.$fetchingState,
);

export const selectFilteredBoothIds = createSelector(
  [selectBoothsState, selectAllValidBoothIds],
  (state, boothIds) => state.filteredBoothIds.filter((id) => boothIds.includes(id)),
);

export const selectTotalFilteredBoothsCount = createSelector(
  selectBoothsState,
  (state) => state.totalFilteredBoothsCount,
);

export const selectAllFilteredBooths = createSelector(
  [selectBoothEntities, selectFilteredBoothIds],
  (boothEntities, filteredBoothIds) => (
    filteredBoothIds.map((id) => boothEntities[id])
  ),
);

export const boothIdsGroupedByTierIds = createSelector(
  [selectAllBoothTiers, selectAllFilteredBooths],
  (tiers, filteredBooths) => tiers.reduce((result, tier) => {
    const tierId = tier?.id;
    result[tierId] = filteredBooths
      .filter((booth) => booth?.tier?.id === tierId)
      .map((booth) => booth.id);
    return result;
  }, {}),
);
